import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage, Invoice } from 'types';
import { client } from 'utils/api-client';

export default function useReopenInvoice(): UseMutationResult<
  AxiosResponse<Invoice>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const reopenInvoice = (invoiceId: string): Promise<AxiosResponse<Invoice>> => {
    return client.post(`invoices/${invoiceId}/reopen/`);
  };

  return useMutation(reopenInvoice, {
    onSuccess: () => {
      queryClient.invalidateQueries('invoices');
      queryClient.invalidateQueries('upcoming-revenue');
      queryClient.invalidateQueries('past-due-payments');
    },
  });
}
